import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserRoleModel } from '../user-role.model';
import { RequestType, AllowedUserRoleMappings, AllowedRoleLabelByMapping } from '../user-role.details';
import {
  UserRoleElement,
  UserRoles,
  StatusMessages,
} from '../user-role.interface';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { NgRedux, select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { CommonDispatcher } from '../../../store/common/common-dispatcher';
import { MatTableDataSource } from '@angular/material';
import { UserRoleDispatcher } from '../../../store/user-role/user-role-dispatcher';
import { SideNavService } from '../../services/sidenav-service/sidenav.service';
import { AppState } from '../../../store/state.model';
import { Subscription } from 'rxjs';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-role-get-form',
    templateUrl: './user-role-get.component.html',
    styleUrls: ['./user-role-get.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgIf, MatIcon, MatSuffix, MatError, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, TranslatePipe]
})
export class UserRoleGetFormComponent
  implements OnInit, OnDestroy, AfterViewInit {
  /**
   * @Property to hold the displayed columns
   **/
  public showTable;
  /**
   *@var to store  input fields.
   **/
  public form_get_role: UntypedFormGroup;
  /**
   *@var to store the model
   **/
  public model: UserRoleModel;
  /**
   *@var to store the table data
   **/
  public dataSource: MatTableDataSource<UserRoleElement>;
  /**
   *@var to dislay columns in the table
   **/
  public displayedColumns = [
    'name',
    'email_address',
    'status',
    'roles',
    'action',
  ];
  /**
   * @Property to hold the user roles
   **/
  private userRoles: UserRoles;
  /**
   * subscriptionGetCall subscription of user roles
   **/
  private getCallSubscriper: Subscription;
  /**
   * subscriptionUpdateCall subscription of new user roles
   **/
  private UpdateCallSubscriper: Subscription;
  /**
   *@arg  observe api variable in redux
   **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public fb: UntypedFormBuilder,
    public translate: TranslationService,
    private apiDispatcher: ApiResponseDispatcher,
    public dispatcher: CustomerDispatcher,
    private snackBar: SnackBarService,
    public orch: OrchestrationService,
    public customerDispatcher: CustomerDispatcher,
    public common: CommonDispatcher,
    public ngRedux: NgRedux<AppState>,
    public userRoleDispatcher: UserRoleDispatcher,
    public sidenav: SideNavService
  ) { }
  /**
   * @function onGetRolesSuccess  api call on success
   */
  public onGetRolesSuccess(response: object): void {
    this.showTable = true;
    this.setTableData(response['userRoles']);
  }
  /**
   * @function onGetRolesError  api call on failure
   */
  public onGetRolesError(): void {
    this.showTable = false;
    this.showMessage(null, RequestType.getUserRoles);
  }
  /**
   * @function setTableData set table data
   */
  setTableData(userRoles: UserRoles | null) {
  if (!userRoles || !userRoles.userEmail) {
    this.showTable = false;
    this.dataSource = new MatTableDataSource();
    return;
  }

  this.userRoles = userRoles;

  const roles = userRoles.roles ? userRoles.roles : [];
  const allowedRoleNames = roles
    .map((role) => role.roleName)
    .filter((roleName) => AllowedUserRoleMappings.includes(roleName));

  this.dataSource = new MatTableDataSource([
    {
      name: userRoles.userEmail.split('@')[0].replace(/\./g, ' '),
      email_address: userRoles.userEmail,
      status: 'Active',
      roles: allowedRoleNames,
    },
  ]);
}
  /**
   * @function showMessage show snack-bar message
   */
  public showMessage(status: StatusMessages | null, type: string) {
    const responseMessages = !!status
      ? status.messages
        .map((message) => this.translateOf(message.description, type))
        .join(', ')
      : this.translateOf('error', type);
    this.snackBar.showToast(responseMessages);
  }

  /**
   * @function getRoles show role name with translation applied or make it readable
   */
  public getRoles(roles: Array<string>): string {
    return roles
      .map((role_name: string): string => {
        if (AllowedRoleLabelByMapping[role_name]) {
          return AllowedRoleLabelByMapping[role_name];
        }
        return role_name.replace(/_/g, ' ');
      })
      .join(', ');
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.setDefaults();
    this.apiObservable.subscribe((api) => {
      if (
        ApiResponseActions.SET_USER_DELETE === api.apiAction &&
        !!api.userDelete['type']
      ) {
        if (api.userDelete['type'] === 'success') {
          this.showTable = false;
        }
      }
    });
  }

  /**
   * @function ngAfterViewInit Method to add subscribtion and list of role calls
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.orch.callUserRoleListApi();
    }, 1);
    this.subscribeGetResponse();
    this.subscribeUpdateResponse();
  }

  /**
   * @function subscribeGetResponse Method to add subscribtion call of user role for the given email.
   */
  subscribeGetResponse() {
    this.getCallSubscriper = this.apiObservable.subscribe((api) => {
      if (
        this.model &&
        ApiResponseActions.SET_USER_ROLE === api.apiAction &&
        !!api.userRole['type']
      ) {
        if (api.userRole['type'] === 'success' && !!api.userRole['payload']) {
          this.onGetRolesSuccess(api.userRole['payload']);
          this.showMessage(api.userRole['status'], RequestType.getUserRoles);
        } else {
          this.onGetRolesError();
        }
      }
    });
  }

  /**
   * @function subscribeUpdateResponse Method to add subscribtion call of user role update
   */
  subscribeUpdateResponse(): void {
    this.UpdateCallSubscriper = this.apiObservable.subscribe((api) => {
      if (
        ApiResponseActions.SET_USER_ROLE_UPDATE === api.apiAction &&
        !!api.userRoleUpdate['type']
      ) {
        if (api.userRoleUpdate['type'] === 'success') {
          this.showMessage(
            api.userRoleUpdate['status'],
            RequestType.updateUserRoles
          );
          this.apiDispatcher.setUserRoleUpdate({});
          this.submitUser(); // Refresh the search after the successful update.
        } else {
          this.showMessage(null, RequestType.updateUserRoles);
        }
      }
    });
  }
  /**
   * @function ngOnDestroy Method to clean when component exit from view and make a clean room after a new visit
   */
  ngOnDestroy(): void {
    this.showTable = false;
    this.form_get_role.reset();
    this.model.clearRequestAttributes();
    this.apiDispatcher.setUserRole({});
    this.userRoleDispatcher.resetUpdate();
    this.sidenav.close();
    if (this.getCallSubscriper) {
      this.getCallSubscriper.unsubscribe();
    }
    if (this.UpdateCallSubscriper) {
      this.UpdateCallSubscriper.unsubscribe();
    }
    delete this.model;
    delete this.form_get_role;
    delete this.dataSource;
    delete this.sidenav;
  }

  /**
   * setDefaults Default data that set for the form
   **/
  public setDefaults(): void {
    this.showTable = false;
    this.model = new UserRoleModel();
    this.form_get_role = this.fb.group(this.model.formGetRole);
  }
  /**
   * Get role Initiates submission calls for getting user roles.
   **/
  public submitUser(): void {
    this.model.error = false;
    this.defaults();
    this.orch.submitUser(this.model.requestAttributes);
  }
  /**
   * onKeyUp updates the form value
   **/
  public onKeyUp(): void {
    this.form_get_role.controls.userEmail.setValue(
      (this.form_get_role.controls.userEmail.value || '')
        .replace(/ /g, '')
        .trim()
    );
    this.form_get_role.controls.userEmail.updateValueAndValidity();
  }
  /**
   * defaults settings before api call
   **/
  public defaults(): void {
    this.model.setRequestAttributes(
      this.form_get_role,
      RequestType.getUserRoles
    );
  }
  /**
   * clear clear action
   **/
  public clear(): void {
    this.showTable = false;
    this.form_get_role.reset();
    this.dataSource = new MatTableDataSource();
    this.model.clearRequestAttributes();
    this.sidenav.close();
    this.redirect();
  }

  /**
   * redirect redirects to the next route
   **/
  public redirect(): void {
    this.router.navigate(['/dashboard/user_role']);
  }
  /**
   * add translator meesage for the given response description
   **/
  public translateOf(messageDescription: string, type: string): string {
    if (messageDescription === 'Request Completed Successfully') {
      return this.translate.getCustomTranslation(
        type === RequestType.getUserRoles
          ? this.model.placeholder.successGetMessage
          : this.model.placeholder.successUpdateMessage
      )['value'];
    }
    return this.translate.getCustomTranslation(
      type === RequestType.getUserRoles
        ? this.model.placeholder.errorGetMessage
        : this.model.placeholder.errorUpdateMessage
    )['value'];
  }

  /**
   * @method toggleSidenav toggles the side nav
   **/
  public toggleSidenav(type: string): void {
    this.userRoleDispatcher.setUpdateInfo(
      type,
      {
        email_address: type === 'update-user-role' ? this.userRoles.userEmail : '',
        roles: type === 'update-user-role' ? this.userRoles.roles.filter((role) => AllowedUserRoleMappings.includes(role.roleName)).map((role) => {
              return { roleID: role.roleID, roleName: role.roleName };
            }) : [],
        userType: type == 'update-user-role' ? this.userRoles.userType : ''
      },
      this.ngRedux.getState().userRole.roleList
    );
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }
}
